/* src/app/modules/ct-status/components/cts-gantry-event-details/cts-gantry-event-details.component.scss */
:host {
  display: flex;
  flex-direction: column;
}
header {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-end;
}
header app-back-to-system-overview {
  flex: 1;
}
header sh-text {
  width: max-content;
  margin-bottom: 0.5rem;
}
sh-tabs {
  width: 100%;
}
.tabs-timezone {
  position: relative;
}
.tabs-timezone app-cts-gantry-timezone-select {
  position: absolute;
  right: 0;
  top: 0;
  margin-top: 0.5rem;
}
/*# sourceMappingURL=cts-gantry-event-details.component.css.map */
